<template>
  <div class="">
    <div class="flex flex-col gap-y-2.5">
      <div class="flex flex-col items-center justify-center w-full">
        <div class="flex items-center text-lg mt-5">
          Фрагмент # {{ audioStart }}/{{ lines.length }}
          <div
            @click="copyFragment(audioStart)"
            class="copy-btn"
            style="fill: #fff"
          >
            <CopyIcon></CopyIcon>
          </div>
        </div>
        <div
          class="w-full mt-3"
          v-loading="fragmentLoading"
          style="min-height: 128px"
        >
          <div id="waveform"></div>
        </div>
      </div>

      <div class="flex items-center gap-x-3 w-full justify-center mt-5">
        <div class="button rounded text-lg font-light w-24">
          {{ timeNormalizer(currentFragmentStartTime + currentAudioTime) }}
        </div>
        <div class="flex items-center gap-x-3">
          <el-tooltip content="Предыдущий фрагмент (Alt + ←)" :show-after="300">
            <el-button class="button" @click="previousFragment">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="height: 20px; width: 20px"
                viewBox="0 0 24 24"
                fill="transparent"
              >
                <path
                  d="M15 5L9 12L15 19"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </el-button>
          </el-tooltip>
          <el-tooltip
            content="Воспроизводить и приостанавливать (Escape)"
            :show-after="300"
          >
            <div class="button" @click="playPause">
              <div v-if="isPlaying">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style="height: 20px; width: 20px"
                  viewBox="0 0 24 24"
                  fill="transparent"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                  <path
                    d="M8 9.5C8 9.03406 8 8.80109 8.07612 8.61732C8.17761 8.37229 8.37229 8.17761 8.61732 8.07612C8.80109 8 9.03406 8 9.5 8C9.96594 8 10.1989 8 10.3827 8.07612C10.6277 8.17761 10.8224 8.37229 10.9239 8.61732C11 8.80109 11 9.03406 11 9.5V14.5C11 14.9659 11 15.1989 10.9239 15.3827C10.8224 15.6277 10.6277 15.8224 10.3827 15.9239C10.1989 16 9.96594 16 9.5 16C9.03406 16 8.80109 16 8.61732 15.9239C8.37229 15.8224 8.17761 15.6277 8.07612 15.3827C8 15.1989 8 14.9659 8 14.5V9.5Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                  <path
                    d="M13 9.5C13 9.03406 13 8.80109 13.0761 8.61732C13.1776 8.37229 13.3723 8.17761 13.6173 8.07612C13.8011 8 14.0341 8 14.5 8C14.9659 8 15.1989 8 15.3827 8.07612C15.6277 8.17761 15.8224 8.37229 15.9239 8.61732C16 8.80109 16 9.03406 16 9.5V14.5C16 14.9659 16 15.1989 15.9239 15.3827C15.8224 15.6277 15.6277 15.8224 15.3827 15.9239C15.1989 16 14.9659 16 14.5 16C14.0341 16 13.8011 16 13.6173 15.9239C13.3723 15.8224 13.1776 15.6277 13.0761 15.3827C13 15.1989 13 14.9659 13 14.5V9.5Z"
                    stroke="currentColor"
                    stroke-width="1.5"
                  />
                </svg>
              </div>
              <div v-else>
                <div
                  style="height: 20px; width: 20px"
                  class="flex items-center justify-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    style="height: 12px; width: 12px"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M20.4086 9.35258C22.5305 10.5065 22.5305 13.4935 20.4086 14.6474L7.59662 21.6145C5.53435 22.736 3 21.2763 3 18.9671L3 5.0329C3 2.72368 5.53435 1.26402 7.59661 2.38548L20.4086 9.35258Z"
                      stroke="currentColor"
                      stroke-width="1.5"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </el-tooltip>
          <el-tooltip
            content="Следующий фрагмент (Alt + →)"
            :show-after="300"
            :disabled="notAllowedNext"
          >
            <el-button
              :disabled="notAllowedNext"
              class="button"
              @click="nextFragment"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style="height: 20px; width: 20px"
                viewBox="0 0 24 24"
                fill="transparent"
              >
                <path
                  d="M9 5L15 12L9 19"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </el-button>
          </el-tooltip>
          <select class="speed_options" v-model="speed" @change="changeSpeed">
            <option
              v-for="s in speeds"
              :key="s"
              :value="s"
              class="flex items-center"
            >
              {{ s }}x
            </option>
          </select>
        </div>
      </div>
      <audio ref="audio" :src="`${audioSrc}`"></audio>
    </div>
  </div>
</template>

<script>
import apiClient from "@/api/api-client";
import WaveSurfer from "wavesurfer.js";
import CopyIcon from "@/icons/CopyIcon.vue";
import { ElMessage } from "element-plus";

const audioContext = new (window.AudioContext || window.webkitAudioContext)();

export default {
  components: { CopyIcon },
  props: {
    fileId: {
      type: String,
    },
    cue: {
      type: Number,
      default: 0,
    },
    lines: {
      type: Array,
      default: () => [],
    },
    notAllowedNext: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      waveSurfer: null,
      waveformFragment: null,
      canvas: null,
      context: null,
      channel: "",
      audioStart: 1,

      isPlaying: false,
      currentAudioSource: null,
      currentAudioTime: 0,

      speed: 1,
      speeds: [0.5, 0.75, 1],
      audio: [],
      fragmentLoading: true,
      chunks: [],

      //activity detector
      activityDetected: false,
      activityTimer: null,
    };
  },
  computed: {
    duration() {
      if (
        this.waveSurfer &&
        typeof this.waveSurfer.getDuration === "function"
      ) {
        const duration = this.waveSurfer.getDuration();
        // Ensure duration is a valid number
        if (!isNaN(duration) && duration > 0) {
          return duration;
        }
      }
      return 0; // Return 0 if duration is invalid or WaveSurfer is not ready
    },
    audioURL() {
      return (
        (this.audio &&
          this.audio.data &&
          this.audio.data.data &&
          this.audio.data.data.meta &&
          this.audio.data.data.meta.url_hash) ||
        ""
      );
    },
    MEDIA_DOMAIN() {
      return window.domain;
    },
    audioSrc() {
      if (this.audioURL) {
        return `${this.MEDIA_DOMAIN}${this.audioURL}`;
      } else {
        return "";
      }
    },
    currentFragmentStartTime() {
      return (
        (this.chunks &&
          this.audioStart &&
          this.chunks[this.audioStart - 1] &&
          this.chunks[this.audioStart - 1].start) ||
        0
      );
    },
  },
  watch: {
    audioStart(newStart) {
      const newFragment = this.lines[newStart - 1];
      if (newFragment) {
        this.pauseCurrentFragment();
        this.isPlaying = false;
      }
    },
  },
  async mounted() {
    await this.getAudio();
    await this.processAudio();
    if (this.chunks && this.chunks.length > 0) {
      this.initializeWaveSurferFragment();
    } else {
      this.fragmentLoading = false;
    }
    window.addEventListener("keydown", this.handleSpacebar);
    window.addEventListener("keydown", this.handleFragment);
    this.startActivityTracking();
  },
  beforeUnmount() {
    if (this.waveSurfer) {
      this.waveSurfer.destroy();
    }
    if (this.waveformFragment) {
      this.waveformFragment.destroy();
    }
    window.removeEventListener("keydown", this.handleFragment);
    window.removeEventListener("keydown", this.handleSpacebar);
    this.stopActivityTracking();
  },

  methods: {
    copyFragment(fragment) {
      navigator.clipboard
        .writeText(`Фрагмент # ${fragment}`)
        .then(() => {
          ElMessage({
            message: `Скопировано: Фрагмент # ${fragment}`,
            type: "success",
            customClass: "my-custom-message",
            duration: 3000,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async processAudio() {
      const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
      const response = await fetch(this.audioSrc);
      const arrayBuffer = await response.arrayBuffer();
      const fullBuffer = await audioCtx.decodeAudioData(arrayBuffer);

      const chunks = [];

      for (const line of this.lines) {
        const { start, end, channel: speakerChannel } = line;
        const sampleRate = fullBuffer.sampleRate;

        const startFrame = Math.round(start * sampleRate);
        const frameCount = Math.round((end - start) * sampleRate);
        const endFrame = startFrame + frameCount;

        const channelIndex = speakerChannel === "user" ? 1 : 0;

        if (channelIndex >= fullBuffer.numberOfChannels) {
          console.warn(`Channel ${channelIndex} not found in audio`);
          continue;
        }

        const slicedBuffer = audioCtx.createBuffer(1, frameCount, sampleRate);
        const sourceData = fullBuffer
          .getChannelData(channelIndex)
          .subarray(startFrame, endFrame);
        slicedBuffer.copyToChannel(sourceData, 0);

        const wavBlob = await this.bufferToWavBlob(slicedBuffer);
        const url = URL.createObjectURL(wavBlob);

        chunks.push({ ...line, url });
      }

      this.chunks = chunks;
    },

    async bufferToWavBlob(buffer) {
      const numChannels = buffer.numberOfChannels;
      const length = buffer.length * numChannels * 2 + 44;
      const arrayBuffer = new ArrayBuffer(length);
      const view = new DataView(arrayBuffer);

      function writeString(view, offset, string) {
        for (let i = 0; i < string.length; i++) {
          view.setUint8(offset + i, string.charCodeAt(i));
        }
      }

      const sampleRate = buffer.sampleRate;
      const bitsPerSample = 16;
      const blockAlign = (numChannels * bitsPerSample) / 8;
      const byteRate = sampleRate * blockAlign;

      writeString(view, 0, "RIFF");
      view.setUint32(4, 36 + buffer.length * blockAlign, true);
      writeString(view, 8, "WAVE");
      writeString(view, 12, "fmt ");
      view.setUint32(16, 16, true);
      view.setUint16(20, 1, true);
      view.setUint16(22, numChannels, true);
      view.setUint32(24, sampleRate, true);
      view.setUint32(28, byteRate, true);
      view.setUint16(32, blockAlign, true);
      view.setUint16(34, bitsPerSample, true);
      writeString(view, 36, "data");
      view.setUint32(40, buffer.length * blockAlign, true);

      let offset = 44;
      for (let i = 0; i < buffer.length; i++) {
        for (let channel = 0; channel < numChannels; channel++) {
          let sample = buffer.getChannelData(channel)[i];
          sample = Math.max(-1, Math.min(1, sample));
          view.setInt16(offset, sample * 0x7fff, true);
          offset += 2;
        }
      }

      return new Blob([arrayBuffer], { type: "audio/wav" });
    },
    initializeWaveSurferFragment() {
      // Only create WaveSurfer instance if it doesn't exist
      if (!this.waveSurfer) {
        this.fragmentLoading = true;

        this.waveSurfer = WaveSurfer.create({
          container: "#waveform",
          waveColor: "#0080ff",
          progressColor: "#0080ff",
          barWidth: 3,
          barRadius: 2,
          cursorWidth: 2.5,
          cursorColor: "#333",
          interact: true,
          audioContext,
          scrollParent: false, // Prevent scroll during playback
          autoCenter: false,
          mediaControls: false,
          pixelRatio: 1,
        });

        this.waveSurfer.on("play", () => {
          this.isPlaying = true;
        });

        this.waveSurfer.on("pause", () => {
          this.isPlaying = false;
        });

        this.waveSurfer.on("ready", () => {
          console.log("WaveSurfer is ready!", this.waveSurfer);
          this.waveSurfer.setPlaybackRate(Number(this.speed));
          this.fragmentLoading = false;
        });

        this.waveSurfer.on("finish", () => {
          this.waveSurfer.seekTo(0);
          this.waveSurfer.pause();
        });

        this.waveSurfer.on("click", (progress) => {
          this.waveSurfer.seekTo(progress);
          this.waveSurfer.play();
        });
        this.waveSurfer.on("audioprocess", (time) => {
          this.currentAudioTime = time;
        });
      }

      this.loadCurrentFragment();
    },
    loadAudioChunk(url) {
      if (this.waveSurfer) {
        this.waveSurfer.load(url);
      }
    },
    loadCurrentFragment() {
      if (this.chunks && this.chunks.length > 0 && this.audioStart) {
        const currentChunk = this.chunks[this.audioStart - 1]?.url;
        if (currentChunk) {
          this.fragmentLoading = true;
          this.loadAudioChunk(currentChunk);
        }
      }
    },
    changeSpeed() {
      if (this.waveSurfer) {
        this.waveSurfer.setPlaybackRate(Number(this.speed));
      }
    },
    pauseCurrentFragment() {
      if (this.waveSurfer && this.waveSurfer.isPlaying()) {
        this.waveSurfer.pause();
      }

      this.isPlaying = false;
    },
    handleFragment(event) {
      if ((event.altKey || event.metaKey) && event.key === "ArrowLeft") {
        event.preventDefault();
        this.previousFragment();
      } else if (
        (event.altKey || event.metaKey) &&
        event.key === "ArrowRight" &&
        !this.notAllowedNext
      ) {
        event.preventDefault();
        this.nextFragment();
      }
    },
    previousFragment() {
      if (this.audioStart > 1) {
        this.audioStart -= 1;
        this.$emit("previous-fragment", this.audioStart);
        this.initializeWaveSurferFragment();
      }
    },
    nextFragment() {
      if (this.audioStart < this.lines.length) {
        this.audioStart += 1;
        this.$emit("next-fragment", this.audioStart);
        this.initializeWaveSurferFragment();
      }
    },
    async getAudio() {
      this.audio = (await apiClient.get(`file/${this.fileId}`)) || [];
    },
    timeNormalizer(timeInSeconds) {
      var pad = function (num, size) {
          return ("000" + num).slice(size * -1);
        },
        time = parseFloat(timeInSeconds).toFixed(3),
        hours = Math.floor(time / 60 / 60),
        minutes = Math.floor(time / 60) % 60,
        seconds = Math.floor(time - minutes * 60),
        milliseconds = (timeInSeconds % 1).toFixed(3).slice(2);

      // Remove trailing zeroes if they exist
      milliseconds = parseFloat("0." + milliseconds)
        .toFixed(2)
        .slice(2);

      if (timeInSeconds >= 3600) {
        return (
          pad(hours, 2) +
          ":" +
          pad(minutes, 2) +
          ":" +
          pad(seconds, 2) +
          "," +
          milliseconds
        );
      }
      return pad(minutes, 2) + ":" + pad(seconds, 2) + "," + milliseconds;
    },

    playPause() {
      if (this.waveSurfer) {
        if (this.waveSurfer.isPlaying()) {
          this.waveSurfer.pause();
        } else {
          this.waveSurfer.play();
        }
        this.isPlaying = this.waveSurfer.isPlaying();
      }
    },
    handleSpacebar(event) {
      if (event.code === "Escape") {
        event.preventDefault();
        this.playPause();
      }
    },
    startActivityTracking() {
      window.addEventListener("keydown", this.markActivity);
      window.addEventListener("mousedown", this.markActivity);
      window.addEventListener("click", this.markActivity);

      this.activityTimer = setInterval(() => {
        if (this.activityDetected) {
          this.sendActivityPing();
          this.activityDetected = false;
        }
      }, 30000);
    },
    stopActivityTracking() {
      window.removeEventListener("keydown", this.markActivity);
      window.removeEventListener("mousedown", this.markActivity);
      window.removeEventListener("click", this.markActivity);
      clearInterval(this.activityTimer);
    },
    markActivity() {
      this.activityDetected = true;
    },
    async sendActivityPing() {
      try {
        await apiClient.post("/activity", { file_id: this.fileId });
      } catch (err) {
        console.error("Activity ping failed:", err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.copy-btn {
  @apply flex-shrink-0 flex items-center justify-center text-gray-500 ml-2 w-5 h-5 p-0.5 rounded cursor-pointer border border-solid border-transparent;

  &:hover {
    @apply bg-blue-50 border-blue-200 text-blue-500;
  }
}
#waveformFragment {
  cursor: default !important;
}
#waveform ::part(scroll) {
  overflow: hidden !important;
}
#waveformFragment ::part(region) {
  border-radius: 0 !important;
}
.button {
  border: 1px solid transparent;
  background-color: #888d93;
  color: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
  min-width: 30px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  padding: 0 15px;
  cursor: pointer;
}
.speed_options {
  position: relative;
  border: 1px solid transparent;
  background-color: #888d93;
  color: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
  border-radius: 5px;
  height: 40px;
  padding: 0 12px;
  cursor: pointer;
  outline: none;

  /* Remove default arrow */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  text-align: center;
  text-align-last: center;
  line-height: 40px;
  font-size: 14px;
}
</style>
